import { ProjConstants } from './proj.constant';
export const MapConstants = {

  MIN_ZOOM: 6,
  MAX_ZOOM: 11,
  ZOOM_SNAP: 1,
  GEOSERVER_WORKSPACE_NAME: 'HEATWAVE',
  APDIMS_GEOSERVER_WORKSPACE_NAME: 'forecast',
  GEOSERVER_WMS_URL: ProjConstants.GEOSERVER_URL+'new-geoserver/ows/wms',
  APDIMS_WMS_URL: ProjConstants.APDIMS_GEOSERVER_URL+'geoserver/ows/wms',
  // GEOSERVER_WMS_URL: "http://localhost:8080/geoserver/ows/wms",  GEOSERVER_WMTS_URL:ProjConstants.GEOSERVER_URL+"geoserver/gwc/service/wmts?tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/vnd.mapbox-vector-tile&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
  GEOSERVER_WMTS_URL: ProjConstants.GEOSERVER_URL+'new-geoserver/gwc/service/wmts?tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/vnd.mapbox-vector-tile&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
  // GEOSERVER_WMTS_URL: "http://localhost:8080/geoserver/gwc/service/wmts?tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
  // GEOSERVER_WMTS_URL: "https://104.42.115.45:8080/geoserver/gwc/service/wmts?tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
  GEOJSON_LAYER_URL: ProjConstants.GEOSERVER_URL+'new-geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson',
  GEOJSON_LAYER_BOUND_URL: ProjConstants.GEOSERVER_URL+'new-geoserver/HEATWAVE/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson',
  GEOJSON_BOUNDARY_LAYER_URL: ProjConstants.GEOSERVER_URL+'new-geoserver/odisha/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson',
  GEOJSON_SCHOOLS_URL: ProjConstants.GEOSERVER_URL+'new-geoserver/HEATWAVE/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=500000&outputFormat=application%2Fjson',
  // GEOJSON_LAYER_URL: "http://localhost:8080/geoserver/VASSARLABS/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson",
  // GEOSERVER_WMS_URL: "http://localhost:8080/geoserver/ows/wms",
  // GEOSERVER_WMTS_URL: "https://localhost:8080/geoserver/gwc/service/wmts?layer=forecast:INDIA_BLOCK&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
  // GEOJSON_LAYER_URL: "https://localhost:8080/geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=forecast:INDIA_CITY&maxFeatures=50&outputFormat=application%2Fjson",
  GEOSERVER_WMFS_URL: ProjConstants.GEOSERVER_URL+'new-geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=5000000&outputFormat=application%2Fjson&typeName=',
  // GEOSERVER_WMFS_URL: "http://localhost:8080/geoserver/VASSARLABS/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson&typeName=",

  MAP_OPTIONS: {
    minZoom: 6,
    maxZoom: 14,
    zoomSnap: 1,
    zoom: ProjConstants.STATE_INFO.ZOOM_LEVEL,
    center: ProjConstants.STATE_INFO.CENTER,
    zoomControl: false,
    zoomAnimation: true,
    maxBounds: [
      [40, 66],
      [5, 99]
    ],
    maxBoundsViscosity: 1.0,
  },

  GROUP_LIST: {
    BASE_LAYER: {
      groupName: 'baseLayers',
      LayerList: {
        BASE_LAYER1: {
          url: 'http://geoserver.vassarlabs.com:8080/geoserver/gwc/service/wmts?layer=baselayer:irrigation_ap_base_layer&style&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
          options: {
            maxZoom: 10,
            opacity: 1,
            format: 'image/png',
            visible: true,
            transparent: true,
            pane: 'base'
          }
        },
        BASE_LAYER2: {
          url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png',
          options: {
            maxNativeZoom: 14,
            maxZoom: 14,
            visible: false
          }
        },
        BASE_LAYER3: {
          url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          options: {
            maxZoom: 22,
            maxNativeZoom: 18,
            visible: false
          }
        },
        BASE_LAYER4: {
          url: 'https://{s}.tile.openstreetmap.se/hydda/base/{z}/{x}/{y}.png',
          options: {
            maxZoom: 22,
            maxNativeZoom: 18,
            visible: false
          }
        }
      }
    },
    ADMIN_LAYER: {
      groupName: 'administrativeLayers',
      LayerList: {
        India_Boundary: {
          layers: 'forecast:INDIA_BOUNDARY',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'state',
          fadeAnimation: false
        },
        India_State: {
          layers: 'forecast:INDIA_STATE',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'state',
          fadeAnimation: false
        },
        India_Block: {
          interactive: true,
          rendererFactory: {},
          opacity: 1,
          minZoom: 5,
          maxZoom: 18,
          pane: 'district',
          visible: true,
          transparent: true,
          vectorTileLayerStyles: {},
          getFeatureId: {}
        },
        District: {
          layers: 'forecast:INDIA_DISTRICT',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'district',
          fadeAnimation: false,
          ...{ cql_filter: 'state_name = \'ANDHRA PRADESH\'' },
        },
        ADMIN_LAYER_GROUP: {
          layers: 'forecast:INDIA_FORECAST_ADMIN',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'district',
          fadeAnimation: false,
          viewParams: 'stateName:' + ProjConstants.STATENAME,
        },
        ADMIN_LAYER_GROUP_WITH_MASK: {
          layers: 'forecast:INDIA_FORECAST_ADMIN_WITH_MASK',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'district',
          fadeAnimation: false,
          viewParams: 'stateName:' + ProjConstants.STATENAME,
        },
        BASIN_LAYER_GROUP: {
          layers: 'forecast:INDIA_FORECAST_BASIN',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'district',
          fadeAnimation: false,
          viewParams: 'stateName:' + ProjConstants.STATENAME,
        },
        BASIN_LAYER_GROUP_WITH_MASK: {
          layers: 'forecast:INDIA_FORECAST_BASIN_WITH_MASK',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'district',
          fadeAnimation: false,
          viewParams: 'stateName:' + ProjConstants.STATENAME,
        },
        BLOCK_LAYER: {
          layers: 'forecast:INDIA_BLOCK_FORECAST',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'district',
          fadeAnimation: false,
          minZoom: 9,
          viewParams: 'stateName:' + ProjConstants.STATENAME,
        },
        SUBBASIN_LAYER: {
          layers: 'forecast:INDIA_SUBBASIN',
          opacity: 1,
          format: 'image/png',
          visible: true,
          transparent: true,
          pane: 'district',
          fadeAnimation: false,
          minZoom: 9,
          viewParams: 'stateName:' + ProjConstants.STATENAME,
        }
      },
    },
    HYDROLOGICAL_LAYER: {
      groupName: 'hydrologicalLayers',
      LayerList: [{

      }]
    }
  },

  PANE_LIST: [{
    name: 'base',
    zindex: '390'
  },
  {
    name: 'WA',
    zindex: '395'
  },
  {
    name: 'state',
    zindex: '404'
  },
  {
    name: 'district',
    zindex: '405'
  },
  {
    name: 'block',
    zindex: '406'
  },
  {
    name : 'village',
    zindex: '407'
  },
  {
    name: 'wind',
    zindex: '900'
  },
  {
    name: 'heatMap',
    zindex: '400'
  },
  {
    name: 'marker',
    zindex: '600'
  },
  {
    name: 'popUp',
    zindex: '605'
  },
  {
    name: 'popUpGeoJson',
    zindex: '630'
  },
  {
    name: 'mask',
    zindex: '700'
  },
  {
    name: 'mark',
    zindex: '1000'
  },
  {
    name: 'popup',
    zindex: '1100'
  },
  {
    name: 'country',
    zindex: '1200'
  }
  ],
  'ANDHRA PRADESH_DISTRICT_CENTERS': {
    SRIKAKULAM: [18.5966262004522, 84.0224048083213],
    VIZIANAGARAM: [18.4735481545195, 83.3858386555812],
    VISAKHAPATNAM: [17.8936023825239, 82.6947980957017],
    'EAST GODAVARI': [17.2658027731284, 81.8986795588705],
    'WEST GODAVARI': [16.9430146264248, 81.379441738496],
    KRISHNA: [16.5566086126404, 80.7977739848276],
    GUNTUR: [16.2927302226394, 80.079783212914],
    PRAKASAM: [15.61698525145, 79.5153706188174],
    KURNOOL: [15.5330814140012, 77.9993085336652],
    ANANTAPUR: [14.4818169912605, 77.5731885734689],
    'Y.S.R.': [14.4642727232773, 78.7808551468929],
    CHITTOOR: [13.4651365530113, 79.0062772599143],
    'SRI POTTI SRIRAMULU NELLORE': [14.4194047546224, 79.7393184407578],
  },

  'ANDHRA PRADESH_BASIN_CENTERS': {
    PENNAR: [[14.4473668344672, 78.3375102280954], 8],
    GODAVARI: [[19.5135491412722, 78.8783014616089], 7],
    KRISHNA: [[16.4733702902386, 76.5248208348432], 7],
    'EAST FLOWING RIVERS BETWEEN VAMSADHARA AND MAHANADI': [[19.4606439967577, 84.527547414506], 9],
    VAMSADHARA: [[19.2615018937754, 83.8672197674548], 9],
    NAGAVALI: [[18.8838512922589, 83.4126418918114], 9],
    'EAST FLOWING RIVERS BETWEEN NAGAVALI AND GODAVARI': [[17.7319949457882, 82.7351926906814], 9],
    'EAST FLOWING RIVERS BETWEEN PENNAR AND KANYAKUMARI': [[12.740002115948, 79.1187608785279], 8],
    'EAST FLOWING RIVERS BETWEEN MAHANADI AND PENNAR': [[15.6347885852424, 79.6915202025281], 9]
  },
  KERALA_DISTRICT_CENTERS: {
    ALAPPUZHA: [9.42355796763855, 76.4495797394205],
    ERNAKULAM: [10.057657883264, 76.4726817122459],
    IDUKKI: [9.88219788264889, 77.0274633278269],
    KANNUR: [12.0006331208277, 75.5262377373719],
    KASARAGOD: [12.4628175053274, 75.1536815693384],
    KOLLAM: [8.96099052097815, 76.8748698173215],
    KOTTAYAM: [9.63706545987625, 76.6509193508865],
    KOZHIKODE: [11.4848010541012, 75.8343612391419],
    MALAPPURAM: [11.1320661057279, 76.1557811482582],
    PALAKKAD: [10.7946411736617, 76.5585836453913],
    PATHANAMTHITTA: [9.28406065936551, 76.9289672359619],
    THIRUVANANTHAPURAM: [8.60845769869476, 77.0150003197013],
    THRISSUR: [10.4711779879786, 76.3161502936397],
    WAYANAD: [11.7112463870856, 76.098133261901]
  },

  KERALA_BASIN_CENTERS: {
    'WEST FLOWING RIVERS FROM TADRI TO KANYAKUMARI': [[11.0855872261243, 76.1273500710767], 8],
    CAUVERY: [[11.7412528063732, 77.4546473718084], 8],
    'EAST FLOWING RIVERS BETWEEN PENNAR AND KANYAKUMARI': [[9.56326043221864, 78.1410487414574], 8]
  },
  KARNATAKA_DISTRICT_CENTERS: {
    'BANGALORE RURAL': [13.2256680225161, 77.5750111468754],
    BAGALKOT: [16.2205490591838, 75.625375575822],
    BELGAUM: [16.1194421170524, 74.8229819738764],
    BANGALORE: [12.9508349652613, 77.5959361111257],
    BELLARY: [15.1095629854264, 76.5333572448606],
    BIJAPUR: [16.7937240975897, 75.9530962880307],
    CHITRADURGA: [14.1675025368757, 76.516425959019],
    BIDAR: [17.9528289692274, 77.2264537918213],
    CHAMRAJNAGAR: [11.9568942062878, 77.0997546903312],
    CHIKKABALLAPURA: [13.5782317146533, 77.8361893466923],
    CHIKMAGALUR: [13.4542743468748, 75.6913440990417],
    'DAKSHINA KANNADA': [12.838220600101, 75.2666509213641],
    DAVANAGERE: [14.4080321017917, 75.954769829468],
    DHARWAD: [15.3893519381003, 75.1538389617504],
    UDUPI: [13.466688749535, 74.8834979696359],
    GADAG: [15.4310659705087, 75.666277999305],
    GULBARGA: [17.26017443381, 76.8694881939408],
    HASSAN: [12.995355656657, 76.1090638251852],
    HAVERI: [14.738084054737, 75.4177143014293],
    KODAGU: [12.3243641128749, 75.8032746001278],
    KOLAR: [13.139327997599, 78.2176931807245],
    KOPPAL: [15.5617493345546, 76.2218657591791],
    MANDYA: [12.6103556544894, 76.7979567857917],
    MYSORE: [12.2088018101812, 76.4421191830192],
    RAICHUR: [16.0894738368189, 76.8931467790937],
    RAMANAGARA: [12.6785471502196, 77.3364986532026],
    SHIMOGA: [14.043552834777, 75.220650401008],
    TUMKUR: [13.5202276511631, 76.9476668751789],
    'UTTARA KANNADA': [14.7940903193259, 74.6229174978987],
    YADGIR: [16.6264115407192, 76.913636317456]
  },
  KARNATAKA_BASIN_CENTERS: {
    KRISHNA: [[16.4733702902386, 76.5248208348432], 7],
    GODAVARI: [[19.5135491412722, 78.8783014616089], 7],
    PENNAR: [[14.4473668344672, 78.3375102280954], 8],
    CAUVERY: [[11.7412528063732, 77.4546473718084], 8],
    'WEST FLOWING RIVERS FROM TAPI TO TADRI': [[17.9307247437539, 73.6196091778336], 7],
    'WEST FLOWING RIVERS FROM TADRI TO KANYAKUMARI': [[11.0855872261243, 76.1273500710767], 8],
    'EAST FLOWING RIVERS BETWEEN PENNAR AND KANYAKUMARI': [[12.740002115948, 79.1187608785279], 8]
  },
  ORISSA_DISTRICT_CENTERS: {
    ANUGUL: [20.9863655823962, 84.9089593849978],
    BALANGIR: [20.5904622575193, 83.1738825992809],
    BALESHWAR: [21.4897786255812, 86.9170445748969],
    BARGARH: [21.2202245391956, 83.3534407075144],
    BAUDA: [20.6468148215157, 84.1776448960245],
    BHADRAK: [20.9858586784155, 86.6254019966166],
    CUTTACK: [20.4495929198052, 85.7057445100362],
    PURI: [19.8765477742454, 85.7208942044356],
    DEBAGARH: [21.4659356317508, 84.8037143617416],
    RAYAGADA: [19.3622778123763, 83.5138447994647],
    DHENKANAL: [20.8261748100547, 85.5262128156634],
    SUNDARGARH: [22.0797762056661, 84.5105774348901],
    GAJAPATI: [19.173382722386, 84.1606801619715],
    GANJAM: [19.6269331401265, 84.6710682895895],
    JAGATSINGHAPUR: [20.2218201841643, 86.3436509283638],
    JAJAPUR: [20.8559284733907, 86.1521972714568],
    JHARSUGUDA: [21.8059851305567, 83.9547338855308],
    KALAHANDI: [19.8676985661373, 83.1092314033699],
    KANDHAMAL: [20.1288956922167, 84.047243115595],
    KENDRAPARA: [20.5531262058133, 86.60969881797],
    KENDUJHAR: [21.5370810374143, 85.7050722619053],
    SAMBALPUR: [21.4519119521294, 84.2809338855484],
    KHORDHA: [20.08996267837, 85.5114179696615],
    KORAPUT: [18.8186186018441, 82.7147002846974],
    MALKANGIRI: [18.2580675076327, 81.956331247629],
    MAYURBHANJ: [21.8951716145781, 86.4111794587727],
    NABARANGAPUR: [19.5880420977429, 82.3376637543873],
    NAYAGARH: [20.2130572405806, 84.9994379387485],
    NUAPADA: [20.4656624386398, 82.5783146726301],
    SUBARNAPUR: [20.9315356590141, 83.8248629734636]
  },
  ORISSA_BASIN_CENTERS: {
    'EAST FLOWING RIVERS BETWEEN MAHANADI AND PENNAR': [[15.6347885852424, 79.6915202025281], 9],
    MAHANADI: [[21.208026291573, 83.1047332514836], 8],
    GODAVARI: [[19.5135491412722, 78.8783014616089], 7],
    'BRAHMANI AND BAITARNI': [[21.8357621468226, 85.3295467325283], 8],
    GANGA: [[25.8640778941876, 80.8629732981557], 6],
    SUBERNAREKHA: [[22.4107734659168, 86.2948982008407], 8],
    'EAST FLOWING RIVERS BETWEEN VAMSADHARA AND MAHANADI': [[19.4606439967577, 84.527547414506], 9],
    VAMSADHARA: [[19.2615018937754, 83.8672197674548], 9],
    NAGAVALI: [[18.8838512922589, 83.4126418918114], 9],
    'EAST FLOWING RIVERS BETWEEN NAGAVALI AND GODAVARI': [[17.7319949457882, 82.7351926906814], 9],
  },

  ZOOM_MAPPING: {
    6: [1],
    7: [1],
    8: [1, 2],
    9: [1, 2, 3],
    10: [1, 2, 3, 4],
    11: [1, 2, 3, 4, 5]
  },

  COMPONENT_TEXT_LAYER_COLOR: {
    RAINFALL: 'color:#000000',
    TEMPERATURE: 'color:#FFFFFF',
    WINDSPEED: 'color:#FFFFFF',
    HUMIDITY: 'color:#FFFFFF'
  },

  COMPONENT_WMS_LAYER_COLOR: {
    RAINFALL: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',

    TEMPERATURE: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',

    WINDSPEED: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#000000;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.3;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',

    HUMIDITY: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000'
  }


}
